/* Teewraps theme behaviour. Content is server-rendered and visible without this file; everything here is enhancement.
   In Shopify the cart functions switch to the AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js). */
(() => {
  const root = document.documentElement;
  // has-scrolled: the WhatsApp button waits for the first scroll on touch screens (theme.css, responsive sweep 2026-10-09)
  const scrolled = () => { if (scrollY > 80) { root.classList.add('has-scrolled'); removeEventListener('scroll', scrolled); } };
  addEventListener('scroll', scrolled, { passive: true }); scrolled();
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const inr = (n) => '₹' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });

  // every page opens at the top: in the preview frame, moving between pages kept the previous page's scroll position
  // (a product opened at the bottom). Links to a section (#...) and Back/Forward keep their usual behaviour.
  const freshVisit = !location.hash && performance.getEntriesByType('navigation')[0]?.type !== 'back_forward';
  if (freshVisit) { history.scrollRestoration = 'manual'; scrollTo(0, 0); addEventListener('load', () => scrollTo(0, 0), { once: true }); }

  // Instagram line: silent clips play only while mostly on screen (never with reduced motion or Save-Data);
  // every clip has its own play/pause button, and a viewer's pause sticks until they press play again.
  if (matchMedia('(min-width: 900px)').matches) $$('[data-open-wide]').forEach((d) => { d.open = true; });

  // top bar: the Wix line and the stockist line take turns; pauses on hover/focus, stops after four rounds, still with reduced motion
  const ann = $('[data-announce]');
  if (ann && !reduced) {
    const msgs = $$('p', ann); let i = 0, n = 0, held = false;
    ['pointerenter', 'focusin'].forEach((e) => ann.addEventListener(e, () => { held = true; }));
    ['pointerleave', 'focusout'].forEach((e) => ann.addEventListener(e, () => { held = false; }));
    const t = setInterval(() => {
      if (held) return;
      msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false;
      msgs[i].classList.remove('is-in'); void msgs[i].offsetWidth; msgs[i].classList.add('is-in');
      if (++n >= msgs.length * 4) clearInterval(t);
    }, 5000);
  }

  // review card at the buy button: one review at a time; auto-advances every 6s (not with reduced motion), pauses on hover/focus
  $$('[data-proofs]').forEach((box) => {
    const slides = $$('[data-proof-slide]', box), dots = $$('[data-proof-dot]', box);
    let k = 0, held = false;
    const go = (n) => {
      k = (n + slides.length) % slides.length;
      slides.forEach((s, j) => { const on = j === k; s.classList.toggle('is-on', on); s.toggleAttribute('aria-hidden', !on); s.tabIndex = on ? 0 : -1; });
      dots.forEach((d, j) => d.setAttribute('aria-current', j === k));
    };
    dots.forEach((d, j) => d.addEventListener('click', () => go(j)));
    ['pointerenter', 'focusin'].forEach((e) => box.addEventListener(e, () => { held = true; }));
    ['pointerleave', 'focusout'].forEach((e) => box.addEventListener(e, () => { held = false; }));
    if (!reduced && slides.length > 1) setInterval(() => { if (!held && !document.hidden) go(k + 1); }, 6000);
  });

  const autoplay = !reduced && !navigator.connection?.saveData;
  const igSet = (v, on) => { const b = v.parentElement.querySelector('[data-ig-toggle]'); b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'Pause video' : 'Play video'); };
  const igPlay = (v) => v.play().then(() => igSet(v, true), () => igSet(v, false));
  const igSeen = new IntersectionObserver((es) => es.forEach(({ target: v, isIntersecting }) => {
    if (isIntersecting && autoplay && !v.dataset.held) igPlay(v);
    else if (!isIntersecting && !v.paused) { v.pause(); igSet(v, false); }
  }), { threshold: 0.6 });
  // posters load only when a clip is near the screen, so they never compete with the page's main image
  const igNear = new IntersectionObserver((es) => es.forEach(({ target: v, isIntersecting }) => { if (isIntersecting) { v.poster = v.dataset.poster; igNear.unobserve(v); } }), { rootMargin: '600px' });
  $$('[data-ig-video]').forEach((v) => {
    igNear.observe(v);
    igSeen.observe(v);
    v.parentElement.querySelector('[data-ig-toggle]').addEventListener('click', () => {
      if (v.paused) { delete v.dataset.held; igPlay(v); } else { v.dataset.held = 1; v.pause(); igSet(v, false); }
    });
  });

  $$('[data-ig-step]').forEach((b) => b.addEventListener('click', () => {
    const t = b.closest('.igline').querySelector('[data-ig-track]');
    t.scrollBy({ left: b.dataset.igStep * t.querySelector('.ig-tile').offsetWidth * 2, behavior: reduced ? 'auto' : 'smooth' });
  }));

  const G = window.gsap;
  if (!G) return;

  G.registerPlugin(ScrollTrigger, CustomEase);
  CustomEase.create('tw', '0.23, 1, 0.32, 1'); // the one easing token (same as --ease)
  G.defaults({ ease: 'tw', duration: 0.8 });

  /* ---------- smooth scroll (wheel only; touch stays native) ---------- */
  let lenis = null;
  if (!reduced && fine && window.Lenis) {
    lenis = new Lenis({ lerp: 0.12, wheelMultiplier: 1 });
    if (freshVisit) lenis.scrollTo(0, { immediate: true });
    lenis.on('scroll', ScrollTrigger.update);
    G.ticker.add((t) => lenis.raf(t * 1000));
    G.ticker.lagSmoothing(0);
    $$('a[href^="#"], a[href*=".html#"]').forEach((a) => a.addEventListener('click', (e) => {
      const id = a.getAttribute('href').split('#')[1];
      const t = id && document.getElementById(id);
      if (t && (a.pathname === location.pathname || a.getAttribute('href').startsWith('#'))) { e.preventDefault(); closeMenu(); lenis.scrollTo(t, { offset: -70 }); }
    }));
  }

  /* ---------- header: hide on scroll down, show on scroll up ---------- */
  const header = $('[data-header]');
  let lastY = scrollY;
  addEventListener('scroll', () => {
    const y = scrollY;
    header.classList.toggle('is-hidden', y > 260 && y > lastY + 4);
    if (y < lastY - 4 || y < 260) header.classList.remove('is-hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- menu ---------- */
  const menu = $('[data-menu]');
  const openBtn = $('[data-menu-open]');
  function openMenu() {
    menu.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); lenis?.stop();
    G.fromTo($$('li, .menu-insta', menu), { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, stagger: 0.05, duration: reduced ? 0 : 0.7 });
    $('a', menu).focus();
  }
  function closeMenu() {
    if (menu.hidden) return;
    menu.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); lenis?.start(); openBtn.focus({ preventScroll: true });
  }
  openBtn.addEventListener('click', openMenu);
  $('[data-menu-close]').addEventListener('click', closeMenu);
  $$('a', menu).forEach((a) => a.addEventListener('click', closeMenu));
  addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeMenu(); closeCart(); } });

  /* ---------- opening sequence runs in CSS (html.intro-play); start it from the top of the page ---------- */
  const hero = $('[data-hero]');
  const towels = $$('[data-towel]');
  let placeTowels = () => {};
  if (root.classList.contains('intro-play') && hero) { history.scrollRestoration = 'manual'; scrollTo(0, 0); }

  /* ---------- the drying line: towels ride the rope, sway with speed ---------- */
  const track = $('[data-line-track]');
  if (track) {
    const sag = () => Math.min(innerWidth * 0.045, 46);
    const setters = towels.map((t) => ({ y: G.quickSetter(t, 'y', 'px'), r: G.quickTo(t, 'rotation', { duration: 1.2, ease: 'tw' }), l: G.quickSetter(t.querySelector('.towel-label'), 'y', 'px') }));
    let lastX = track.scrollLeft, lastT = performance.now();
    placeTowels = () => {
      const tr = track.getBoundingClientRect(), now = performance.now();
      const v = (track.scrollLeft - lastX) / Math.max(16, now - lastT);
      lastX = track.scrollLeft; lastT = now;
      towels.forEach((t, k) => {
        const r = t.getBoundingClientRect();
        const u = Math.max(-1, Math.min(1, ((r.left + r.width / 2 - tr.left) / tr.width) * 2 - 1)); // -1..1 along the rope
        const y = sag() * (1 - u * u);
        setters[k].y(y); setters[k].l(sag() - y); // names and prices line up under the lowest towel
        if (!reduced) setters[k].r(Math.max(-7, Math.min(7, -v * 9)));
      });
    };
    track.addEventListener('scroll', () => requestAnimationFrame(placeTowels), { passive: true });
    if (!reduced && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      hero.addEventListener('pointermove', (e) => {
        const x = e.clientX / innerWidth * 2 - 1;
        towels.forEach((t, k) => { const r = t.getBoundingClientRect(); const d = (r.left + r.width / 2) / innerWidth * 2 - 1; setters[k].r(Math.max(-3.5, Math.min(3.5, (x - d) * 3))); });
      });
      hero.addEventListener('pointerleave', () => setters.forEach((st) => st.r(0)));
    }
    track.addEventListener('scrollend', () => setters.forEach((s) => s.r(0)));
    addEventListener('resize', placeTowels);
    placeTowels();
  }

  /* ---------- hero: the cycling print name recolours the page and lifts its towel ---------- */
  const cycler = $('[data-cycler]');
  if (cycler) {
    const names = JSON.parse(cycler.dataset.words);
    const prints = JSON.parse(cycler.dataset.prints);
    const lift = (p) => towels.forEach((t) => t.classList.toggle('is-current', t.dataset.print === p));
    let i = Math.max(0, prints.indexOf(hero.dataset.print)), holdUntil = 0, touched = 0;
    lift(prints[i]);
    const show = (k) => {
      if (k === i || k < 0) return;
      i = k;
      hero.dataset.print = prints[k]; lift(prints[k]); // colour and towel at once; only the name animates
      const set = () => { cycler.textContent = names[k]; };
      if (reduced) return set();
      G.timeline()
        .to(cycler, { clipPath: 'inset(-20% 0 -20% 100%)', duration: 0.4 })
        .add(set)
        .fromTo(cycler, { clipPath: 'inset(-20% 100% -20% 0)' }, { clipPath: 'inset(-20% 0% -20% 0)', duration: 0.7 });
    };
    // the line scrolls only on phones and tablets; there every towel can be centred and the centred one is the colour
    const scrolls = () => track && track.scrollWidth > track.clientWidth + 2;
    const centred = () => {
      const mid = track.getBoundingClientRect().left + track.clientWidth / 2;
      return towels.reduce((a, t) => { const r = t.getBoundingClientRect(); const d = Math.abs(r.left + r.width / 2 - mid); return d < a.d ? { t, d } : a; }, { t: null, d: Infinity }).t;
    };
    const glideTo = (p) => {
      const t = towels.find((x) => x.dataset.print === p);
      if (!t || !scrolls()) return;
      track.scrollTo({ left: t.offsetLeft - (track.clientWidth - t.offsetWidth) / 2, behavior: reduced ? 'auto' : 'smooth' });
    };
    if (track) {
      // phones: start with the hero's towel (Blush) in the middle of the line
      if (scrolls()) { const t = towels.find((x) => x.dataset.print === prints[i]); if (t) { track.scrollLeft = t.offsetLeft - (track.clientWidth - t.offsetWidth) / 2; } }
      // only a real finger, mouse or trackpad on the line counts as a swipe (layout re-snaps and glides do not)
      for (const ev of ['pointerdown', 'touchstart', 'wheel']) track.addEventListener(ev, () => { touched = Date.now(); }, { passive: true });
      let settle = 0;
      track.addEventListener('scroll', () => {
        clearTimeout(settle);
        settle = setTimeout(() => {
          const near = centred();
          if (!near) return;
          if (Date.now() - touched < 3000) holdUntil = Date.now() + 6000; // a person swiped: let them look before the cycle moves on
          show(prints.indexOf(near.dataset.print));
        }, 140);
      }, { passive: true });
    }
    if (!reduced) {
      let visible = true;
      new IntersectionObserver(([e]) => { visible = e.isIntersecting; }).observe(hero);
      // wait for the opening to hand over (it ends on this hero's own colour)
      const cl = root.classList, wait = cl.contains('intro-play') ? (cl.contains('intro-short') ? 1400 : 6400) + 1500 : 0;
      setTimeout(() => setInterval(() => {
        if (!visible || document.hidden || Date.now() < holdUntil) return;
        const k = (i + 1) % names.length;
        if (scrolls()) glideTo(prints[k]); else show(k); // on phones the line moves and its settle sets the colour
      }, 3000), wait);
    }
  }


  /* ---------- opening: CSS plays it; the skip badge (or Escape) ends it at once ---------- */
  if ($('.splash') && root.classList.contains('intro-play')) {
    const skip = () => { root.classList.remove('intro-play'); removeEventListener('keydown', onKey); };
    const onKey = (e) => { if (e.key === 'Escape') skip(); };
    $('[data-skip-intro]')?.addEventListener('click', skip, { once: true });
    addEventListener('keydown', onKey);
    setTimeout(() => removeEventListener('keydown', onKey), 8000);
    setTimeout(skip, (root.classList.contains('intro-short') ? 1400 : 6400) + 2600); // after the last entrance (towels, pill) has played
  }

  /* ---------- floating pill: away over the hero's own button and over the footer ---------- */
  const pill = $('[data-float-pill]');
  if (pill) {
    const states = new Map();
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => states.set(e.target, e.isIntersecting));
      pill.classList.toggle('is-away', [...states.values()].some(Boolean));
    });
    [$('.hero-copy .btn'), $('.site-footer'), $('#wraps')].forEach((el) => el && io.observe(el));
  }

  /* ---------- lazy photos fade in over their dominant colour ---------- */
  if (!reduced) $$('img[loading=lazy]').forEach((im) => {
    if (im.complete) return;
    im.classList.add('fade');
    const on = () => im.classList.add('is-loaded');
    im.addEventListener('load', on, { once: true }); im.addEventListener('error', on, { once: true });
  });

  /* ---------- photo band drifts slower than the page ---------- */
  if (!reduced) $$('[data-parallax]').forEach((f) => G.fromTo(f, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: f.parentElement, start: 'top bottom', end: 'bottom top', scrub: true } }));

  /* ---------- swipeable product photos inside cards and on the product page ---------- */
  $$('[data-track]').forEach((track) => {
    const box = track.parentElement;
    const slides = [...track.children];
    const dots = $$('.card-dots i', box);
    const count = $('[data-count]', box.closest('.pdp-gallery') || box);
    const idx = () => Math.round(track.scrollLeft / track.clientWidth);
    const sync = () => {
      const k = idx();
      dots.forEach((d, j) => d.classList.toggle('on', j === k));
      if (count) count.textContent = k + 1;
      slides.forEach((s, j) => { const a = s.matches('a') ? s : null; if (a) a.tabIndex = j === k ? 0 : -1; });
    };
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    const go = (d) => track.scrollTo({ left: (idx() + d) * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    $('[data-prev]', box)?.addEventListener('click', () => go(-1));
    $('[data-next]', box)?.addEventListener('click', () => go(1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); } });
  });


  /* ---------- scroll stories (set up when the browser is idle) ---------- */
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 200));
  if (!reduced) idle(() => {
    $$('[data-words-reveal]').forEach((el) => {
      const words = el.textContent.trim().split(/\s+/);
      el.innerHTML = `<span class="visually-hidden">${el.textContent.trim()}</span>` + words.map((w) => `<span class="w" aria-hidden="true">${w}</span>`).join(' ');
      const ws = $$('.w', el);
      ScrollTrigger.create({
        trigger: el, start: 'top 85%', end: 'bottom 60%', scrub: true,
        onUpdate: (st) => ws.forEach((w, k) => w.style.setProperty('--o', Math.min(1, Math.max(0.32, st.progress * ws.length * 1.25 - k + 1)))),
      });
    });
    $$('.strike').forEach((s) => G.fromTo(s, { '--strike': '0%' }, { '--strike': '100%', ease: 'none', scrollTrigger: { trigger: s, start: 'top 80%', end: 'top 45%', scrub: true } }));
    $$('.story-photos figure, .intro-fig, .long-fig').forEach((f) => G.from(f, { clipPath: 'inset(12% 8% 12% 8% round 18px)', duration: 1.4, scrollTrigger: { trigger: f, start: 'top 85%', once: true } }));
  });


  /* ---------- per-section scroll choreography (a different move for each section, never twice in a row) ---------- */
  if (!reduced && $('[data-hero]')) idle(() => { // home only
    const once = (trigger, start = 'top 82%') => ({ trigger, start, once: true });
    // category tiles: depth, each photo drifting inside its frame at its own rate
    $$('[data-depth]').forEach((el, k) => {
      G.fromTo($('.cat-img img', el), { yPercent: -7 - k * 2, scale: 1.14 }, { yPercent: 7 + k * 2, scale: 1.04, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    // rope section heads: the rope draws across and the peg drops onto it; the handwritten note writes itself
    $$('.section-head.pegged').forEach((h) => {
      G.fromTo(h, { '--rope': 0 }, { '--rope': 1, duration: 1.3, scrollTrigger: once(h, 'top 88%') });
      G.from($('.peg', h), { y: -36, rotation: -20, opacity: 0, duration: 1, delay: 0.35, scrollTrigger: once(h, 'top 88%') });
      const note = $('.note', h);
      if (note) G.fromTo(note, { clipPath: 'inset(-40% 100% -40% 0)' }, { clipPath: 'inset(-40% 0% -40% 0)', duration: 1.5, delay: 0.5, scrollTrigger: once(h, 'top 85%') });
    });
    // towels and value packs: cards swing down from the rope and settle
    ['#towels', '#value-packs'].forEach((id) => {
      const cards = $$(`${id} .card`);
      if (cards.length) G.from(cards, { y: -46, rotation: (k) => (k % 2 ? 7 : -7), transformOrigin: '50% 0%', opacity: 0, duration: 1.2, stagger: 0.07, scrollTrigger: once(`${id} .rail, ${id} .packs-grid`) });
    });
    // hair wraps: cards unfold top-down like a towel being let go
    G.fromTo('#wraps .card', { clipPath: 'inset(0% 0% 100% 0%)' }, { clipPath: 'inset(0% 0% 0% 0%)', duration: 1.2, stagger: 0.08, scrollTrigger: once('#wraps .rail') });
    // photo band: the handwritten line writes itself word by word under the reader's scroll
    const bandScript = $('.band-script');
    if (bandScript) {
      bandScript.innerHTML = bandScript.textContent.trim().split(/\s+/).map((w) => `<span class="bw">${w}</span>`).join(' ');
      const ws = $$('.bw', bandScript);
      ScrollTrigger.create({
        trigger: '.band', start: 'top 75%', end: 'center 40%', scrub: true,
        onUpdate: (st) => ws.forEach((w, k) => {
          const p = Math.min(1, Math.max(0, st.progress * ws.length - k));
          w.style.clipPath = `inset(-30% ${(1 - p) * 100}% -30% 0)`;
        }),
      });
    }
    // founder story: the two photos drift apart at different speeds, the badge turns with the scroll
    G.to('.story-a', { yPercent: 6, ease: 'none', scrollTrigger: { trigger: '.story', start: 'top bottom', end: 'bottom top', scrub: true } });
    G.to('.story-b', { yPercent: -16, ease: 'none', scrollTrigger: { trigger: '.story', start: 'top bottom', end: 'bottom top', scrub: true } });
    // key features: the rolled towels push in slowly beside the list; the comparison's ticks and crosses draw themselves
    G.fromTo('.feat-fig img', { scale: 1.12, yPercent: -3 }, { scale: 1, yPercent: 3, ease: 'none', scrollTrigger: { trigger: '.features', start: 'top bottom', end: 'bottom top', scrub: true } });
    G.fromTo('.compare .mark path', { strokeDashoffset: 1 }, { strokeDashoffset: 0, duration: 0.7, stagger: 0.12, scrollTrigger: once('.compare', 'top 78%') });
    // mission: the photo settles as you arrive and the card rises onto it
    G.fromTo('.mission-fig img', { scale: 1.22 }, { scale: 1, ease: 'none', scrollTrigger: { trigger: '.mission', start: 'top bottom', end: 'center center', scrub: true } });
    G.from('.mission-copy', { y: 60, opacity: 0, duration: 1.1, scrollTrigger: once('.mission', 'top 60%') });
  });

  /* ---------- marquee: steady drift, faster with scroll speed ---------- */
  const mq = $('[data-marquee]');
  if (mq && !reduced) {
    const half = mq.scrollWidth / 2;
    let mqRest;
    const loop = G.to(mq, { x: -half, duration: 38, ease: 'none', repeat: -1, paused: true });
    ScrollTrigger.create({ trigger: mq, start: 'top bottom', end: 'bottom top', onToggle: (st) => (st.isActive ? loop.play() : loop.pause()), onUpdate: (st) => {
      const dir = st.direction < 0 ? -1 : 1, boost = Math.min(2, 1 + Math.abs(st.getVelocity()) / 900);
      G.to(loop, { timeScale: boost * dir, duration: 0.3, overwrite: true });
      clearTimeout(mqRest); mqRest = setTimeout(() => G.to(loop, { timeScale: dir, duration: 1.2, overwrite: true }), 160);
    } });
  }


  /* ---------- cart (preview mock with the same shape as Shopify's cart) ---------- */
  const V = window.TW_VARIANTS || {};
  const RWC = window.TW_RW || { per: 1, minCart: 1199 };
  const pts = (rs) => Math.floor(rs / RWC.per).toLocaleString('en-IN');
  const cartEl = $('[data-cart]');
  const KEY = 'tw-cart';
  let cart = [];
  // On Shopify (window.TW_SHOP, written by the theme) the cart is Shopify's own (/cart.js); in the preview it lives in localStorage
  const SHOP = window.TW_SHOP || null;
  if (!SHOP) try { cart = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
  const save = () => { if (!SHOP) try { localStorage.setItem(KEY, JSON.stringify(cart)); } catch (e) {} };
  const shopPost = (path, body) => fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());
  async function syncCart() {
    const c = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    cart = c.items.map((it) => { const k = SHOP.byVariant[it.variant_id] || []; return { key: it.key, id: k[0], option: k[1] || '', qty: it.quantity }; }).filter((l) => l.id && V[l.id]);
    renderCart();
  }
  // every change to a line goes through here: Shopify's cart when live, localStorage in the preview
  function setQty(l, q) {
    if (SHOP) return shopPost('/cart/change.js', { id: l.key, quantity: q }).then(syncCart);
    l.qty = q; cart = cart.filter((x) => x.qty > 0); save(); renderCart();
  }
  let justAdded = null;
  function renderCart() {
    const list = $('[data-cart-lines]', cartEl);
    const tpl = $('#cart-line');
    list.innerHTML = '';
    let total = 0, count = 0;
    cart.forEach((l) => {
      const v = V[l.id]; if (!v) return;
      total += v.price * l.qty; count += l.qty;
      const li = tpl.content.firstElementChild.cloneNode(true);
      $('img', li).src = v.img;
      $('.cart-line-name', li).textContent = v.name;
      $('.cart-line-variant', li).textContent = [v.variant, l.option].filter(Boolean).join(' · ');
      $('output', li).textContent = l.qty;
      $('.cart-line-price', li).textContent = inr(v.price * l.qty);
      $('[data-inc]', li).onclick = () => setQty(l, l.qty + 1);
      $('[data-dec]', li).onclick = () => setQty(l, Math.max(0, l.qty - 1));
      $('[data-remove]', li).onclick = () => setQty(l, 0);
      list.appendChild(li);
      if (l === justAdded && !reduced) G.from(li, { y: 10, opacity: 0, duration: 0.4, delay: 0.25 });
    });
    justAdded = null;
    // owner's rules (content/owner-facts.json): Buy 2 Get 30% on offer items, free shipping above the threshold
    const F = window.TW_FACTS || { offer: { pct: 30, minItems: 2, name: 'Buy 2 Get 30%' }, shipping: { freeAbove: 1999, fee: 99 } };
    let offerQty = 0, offerSum = 0;
    cart.forEach((l) => { const v = V[l.id]; if (v?.offer) { offerQty += l.qty; offerSum += v.price * l.qty; } });
    const off = offerQty >= F.offer.minItems ? Math.round((offerSum * F.offer.pct) / 100) : 0;
    const goods = total - off, ship = !count || goods >= F.shipping.freeAbove ? 0 : F.shipping.fee;
    $('[data-cart-subtotal]', cartEl).textContent = inr(total);
    $('[data-cart-offer-row]', cartEl).hidden = !off; $('[data-cart-offer]', cartEl).textContent = '−' + inr(off);
    $('[data-cart-shipfee]', cartEl).textContent = ship ? inr(ship) : 'Free';
    // the total rolls to its new value while the cart is open
    const totEl = $('[data-cart-total]', cartEl), newTotal = goods + ship;
    if (!cartEl.hidden && !reduced && lastTotal !== null && lastTotal !== newTotal) {
      const o = { v: lastTotal };
      G.to(o, { v: newTotal, duration: 0.6, ease: 'power2.out', overwrite: true, onUpdate: () => { totEl.textContent = inr(Math.round(o.v)); } });
    } else totEl.textContent = inr(newTotal);
    lastTotal = newTotal;
    const sh = $('[data-cart-ship]', cartEl); sh.hidden = !count;
    $('[data-cart-ship-text]', sh).textContent = goods >= F.shipping.freeAbove ? 'You have free shipping' : inr(F.shipping.freeAbove - goods) + ' away from free shipping';
    $('[data-cart-bar]', sh).style.transform = 'scaleX(' + Math.min(1, goods / F.shipping.freeAbove) + ')';
    const nudge = $('[data-cart-nudge]', cartEl); nudge.hidden = offerQty !== 1;
    nudge.textContent = 'Add one more towel or hair wrap to unlock ' + F.offer.name;
    const cp = $('[data-cart-pts]', cartEl);
    if (cp) { cp.hidden = !count; const need = RWC.minCart - total; cp.innerHTML = `<b>${pts(total - off)}</b> points with this order · <a href="rewards.html">Rewards</a>`; }
    $('[data-cart-empty]', cartEl).hidden = count > 0;
    const rk = total + '/' + off + '/' + ship; if (rk !== lastRcpt && !cartEl.hidden) printReceipt(); lastRcpt = rk;
    const badge = $('[data-cart-count]');
    badge.hidden = !count; badge.textContent = count;
  }
  // the summary is a receipt: it feeds out of the slot in steps when the cart opens or the total changes
  let lastRcpt = '', lastTotal = null;
  function printReceipt(delay = 0) {
    const p = $('[data-receipt-paper]', cartEl), r = $('[data-receipt]', cartEl); if (!p || reduced) return;
    G.fromTo(p, { yPercent: -100 }, { yPercent: 0, duration: 0.7, delay, ease: 'steps(14)', overwrite: true,
      onStart: () => r.classList.add('is-printing'), onComplete: () => r.classList.remove('is-printing') });
  }
  let shopQueue = Promise.resolve();
  function addToCart(id, qty = 1, option = '') {
    if (SHOP) { // queued, so two adds in a row (complete the set) never race
      const vid = SHOP.variant[id + (option ? '|' + option : '')];
      if (!vid) return shopQueue;
      shopQueue = shopQueue.then(() => shopPost('/cart/add.js', { items: [{ id: vid, quantity: qty }] })).then(syncCart).catch(() => syncCart());
      if (!reduced) G.fromTo('[data-cart-count]', { scale: 1.25 }, { scale: 1, duration: 0.5 });
      return shopQueue;
    }
    let hit = cart.find((l) => l.id === id && l.option === option);
    if (hit) hit.qty += qty; else cart.push(hit = { id, qty, option });
    justAdded = hit;
    save(); renderCart();
    if (!reduced) G.fromTo('[data-cart-count]', { scale: 1.25 }, { scale: 1, duration: 0.5 });
  }
  let lastFocus = null;
  function openCart() {
    lastFocus = qs?.contains(document.activeElement) ? qsFrom : document.activeElement; // from quick add: back to the card's plus
    cartEl.hidden = false; lenis?.stop();
    if (!reduced) {
      const desktop = innerWidth >= 900;
      G.fromTo('.cart-panel', desktop ? { xPercent: 100 } : { yPercent: 100 }, { xPercent: 0, yPercent: 0, duration: 0.45, overwrite: true });
      G.fromTo('.cart-scrim', { opacity: 0 }, { opacity: 1, duration: 0.3, overwrite: true });
    }
    printReceipt(0.25);
    $('.cart-head button', cartEl).focus();
  }
  function closeCart() {
    if (!cartEl || cartEl.hidden) return;
    const done = () => { cartEl.hidden = true; lenis?.start(); lastFocus?.focus?.({ preventScroll: true }); };
    if (reduced || document.hidden) return done(); // hidden pages pause animation frames: never leave the drawer stuck
    G.to('.cart-panel', { ...(innerWidth >= 900 ? { xPercent: 100 } : { yPercent: 100 }), duration: 0.28, overwrite: true, onComplete: done });
    G.to('.cart-scrim', { opacity: 0, duration: 0.28, overwrite: true });
  }
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', openCart));
  // discount code: Shopify checks it at checkout (the theme passes it on); here it is kept and shown
  const codeForm = $('[data-code-form]', cartEl);
  if (codeForm) {
    const CODE = 'tw-code', on = $('[data-code-on]', cartEl), input = $('[data-code-input]', codeForm);
    const show = () => { let c = ''; try { c = localStorage.getItem(CODE) || ''; } catch (e) {} codeForm.hidden = !!c; on.hidden = !c; const wrap = codeForm.closest("[data-code-wrap]"); if (wrap) wrap.hidden = !!c; $('[data-code-name]', on).textContent = c; const nt = $('[data-code-note]', on); if (nt) { nt.dataset.std ??= nt.textContent; nt.textContent = c === 'FERIA10' ? nt.dataset.feria : nt.dataset.std; } }; // FERIA10 is the one code that stacks with the offer
    codeForm.addEventListener('submit', (e) => { e.preventDefault(); const c = input.value.trim().toUpperCase().replace(/\s+/g, ''); if (!c) return input.focus(); try { localStorage.setItem(CODE, c); } catch (err) {} input.value = ''; show(); });
    $('[data-code-remove]', on).addEventListener('click', () => { try { localStorage.removeItem(CODE); } catch (e) {} show(); input.focus(); });
    show();
  }
  $$('[data-cart-close]').forEach((b) => b.addEventListener('click', closeCart));
  // checkout tears the receipt off, then goes on (Shopify's /checkout in the theme; the preview has no checkout, so it reprints)
  const co = $('[data-checkout]', cartEl), rc = $('[data-receipt]', cartEl);
  if (co && rc) co.addEventListener('click', (e) => {
    // a code typed in the cart rides along to Shopify's checkout, which checks it
    let href = co.href;
    if (SHOP) try { const c = localStorage.getItem('tw-code'); if (c) href = '/checkout?discount=' + encodeURIComponent(c); } catch (err) {}
    if (reduced) { if (SHOP) { e.preventDefault(); location.href = href; } return; }
    e.preventDefault();
    rc.classList.add('is-torn');
    setTimeout(() => { if (new URL(href, location.href).hash === '#checkout') { rc.classList.remove('is-torn'); printReceipt(); } else location.href = href; }, 380);
  });
  cartEl.addEventListener('keydown', (e) => { // keep focus inside the open drawer
    if (e.key !== 'Tab') return;
    const f = $$('button, a[href], [tabindex="0"]', cartEl).filter((x) => x.offsetParent);
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
    else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
  });
  /* ---------- help: the round button opens FAQ, Shipping & Returns and WhatsApp ---------- */
  const helpBtn = $('[data-help-btn]'), helpMenu = $('[data-help-menu]');
  if (helpBtn && helpMenu) {
    const setHelp = (open) => {
      helpMenu.hidden = !open; helpBtn.setAttribute('aria-expanded', String(open));
      if (open && !reduced) G.fromTo(helpMenu, { opacity: 0, scale: 0.96, y: 6 }, { opacity: 1, scale: 1, y: 0, duration: 0.22 });
    };
    helpBtn.addEventListener('click', () => { setHelp(helpMenu.hidden); if (!helpMenu.hidden) $('a', helpMenu).focus(); });
    document.addEventListener('click', (e) => { if (!helpMenu.hidden && !e.target.closest('[data-help]')) setHelp(false); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !helpMenu.hidden) { setHelp(false); helpBtn.focus(); } });
  }
  /* ---------- rewards ---------- */
  // floating pill: a link that opens a small panel when JS runs; hides while scrolling down and over the home hero
  const rwBox = $('[data-rw]'), rwBtn = $('[data-rw-btn]'), rwPanel = $('[data-rw-panel]');
  if (rwBox && rwBtn && rwPanel) {
    const setRw = (open) => { rwPanel.hidden = !open; rwBtn.setAttribute('aria-expanded', String(open)); if (open && !reduced) G.fromTo(rwPanel, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.35 }); };
    // on Shopify the pill opens Smile.io's panel (balance, redeem, referral link; Smile's own launcher is switched off)
    rwBtn.addEventListener('click', (e) => { e.preventDefault(); if (SHOP && window.SmileUI) { SmileUI.ready().then(() => SmileUI.openPanel()); return; } setRw(rwPanel.hidden); });
    document.addEventListener('click', (e) => { if (!rwPanel.hidden && !e.target.closest('[data-rw]')) setRw(false); });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && !rwPanel.hidden) { setRw(false); rwBtn.focus(); } });
    const heroEl = $('[data-hero]');
    let lastY = scrollY;
    const place = () => {
      const y = scrollY, down = y > lastY + 4, up = y < lastY - 4;
      const overHero = heroEl && y < heroEl.offsetHeight * 0.6;
      if (overHero || (down && rwPanel.hidden)) rwBox.classList.add('is-away'); else if (up || !heroEl) rwBox.classList.remove('is-away');
      if (down || up) lastY = y;
    };
    addEventListener('scroll', place, { passive: true });
    place();
  }
  // On Shopify: Sign up / Sign in go to Shopify's account pages, the referral link opens Smile's panel (its app embed loads SmileUI).
  // In the preview they explain, next to the button tapped, that the programme opens at launch.
  const smileGo = { register: '/account/register', login: '/account/login' };
  $$('[data-rw-soon]').forEach((b) => b.addEventListener('click', () => {
    if (SHOP) { const a = b.dataset.rwSoon; if (a === 'refer' && window.SmileUI) SmileUI.ready().then(() => SmileUI.openPanel({ deep_link: 'referral_program_details' })); else location.href = smileGo[a] || '/account/login'; return; }
    const box = b.closest('.rwp-hero-copy, .rwp-refer-copy'); const n = box && box.querySelector('.rw-soon'); if (n) n.hidden = false; }));
  // the Rewards page: reveal moments, and the points calculator
  const rv = $$('[data-reveal]');
  if (rv.length) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.3, rootMargin: '0px 0px -10% 0px' });
    rv.forEach((x) => io.observe(x));
  }
  const calcBox = $('[data-calc]');
  if (calcBox) {
    const out = $('[data-calc-pts]', calcBox);
    const total = () => $$('[data-price]', calcBox).reduce((t, li) => t + Number(li.dataset.price) * Number($('output', li).value || $('output', li).textContent), 0);
    $$('[data-price]', calcBox).forEach((li) => {
      const o = $('output', li);
      const step = (d) => { const v = Math.max(0, Math.min(5, Number(o.textContent) + d)); o.textContent = v; out.textContent = pts(total()); out.classList.remove('tick'); void out.offsetWidth; out.classList.add('tick'); };
      $('[data-inc]', li).addEventListener('click', () => step(1));
      $('[data-dec]', li).addEventListener('click', () => step(-1));
    });
  }

  /* ---------- contact form (Shopify's contact form takes over in the theme) ---------- */
  const cform = $('[data-contact-form]');
  cform?.addEventListener('submit', (e) => { e.preventDefault(); $('[data-contact-thanks]', cform).hidden = false; cform.reset(); });
  // back-in-stock sign-up: the preview only confirms; in the theme Shopify's customer form saves the email with a notify tag
  const nform = $('[data-notify-form]');
  nform?.addEventListener('submit', (e) => { e.preventDefault(); $('[data-notify-ok]', nform).hidden = false; nform.reset(); });

  /* ---------- gift card ---------- */

  /* ---------- quick add: the plus on a card (one size: straight to the cart; two sizes: the sheet) ---------- */
  const qs = $('[data-qs]');
  let qsPick = null, qsFrom = null;
  const closeQS = (now) => {
    if (!qs || qs.hidden) return;
    const done = () => { qs.hidden = true; lenis?.start(); if (now !== true) qsFrom?.focus?.({ preventScroll: true }); };
    if (reduced || now === true || document.hidden) { G.killTweensOf(['.qs-panel', '.qs-scrim']); return done(); }
    G.to('.qs-panel', { ...(innerWidth >= 900 ? { opacity: 0, scale: 0.97 } : { yPercent: 100 }), duration: 0.28, overwrite: true, onComplete: done });
    G.to('.qs-scrim', { opacity: 0, duration: 0.28, overwrite: true });
  };
  const openQS = (d, from) => {
    qsFrom = from;
    $('[data-qs-img]', qs).src = d.img;
    $('[data-qs-name]', qs).textContent = d.name;
    const price = $('[data-qs-price]', qs);
    const box = $('[data-qs-sizes]', qs);
    box.innerHTML = '';
    d.v.forEach(([id, label, p], k) => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'chip chip-lg'; b.textContent = label;
      const sp = document.createElement('small'); sp.className = 'chip-price'; sp.textContent = inr(p); b.appendChild(sp); b.setAttribute('aria-pressed', String(!k));
      b.onclick = () => { qsPick = id; price.textContent = inr(p); $$('.chip', box).forEach((x) => x.setAttribute('aria-pressed', String(x === b))); };
      box.appendChild(b);
    });
    qsPick = d.v[0][0]; price.textContent = inr(d.v[0][2]);
    $('[data-qs-guide]', qs).hidden = !d.guide; $('[data-qs-guide]', qs).open = false;
    qs.hidden = false; lenis?.stop();
    if (!reduced) {
      const desktop = innerWidth >= 900;
      G.fromTo('.qs-panel', desktop ? { opacity: 0, scale: 0.97 } : { yPercent: 100 }, { opacity: 1, scale: 1, yPercent: 0, duration: desktop ? 0.35 : 0.45, overwrite: true });
      G.fromTo('.qs-scrim', { opacity: 0 }, { opacity: 1, duration: 0.3, overwrite: true });
    }
    $('.chip', box)?.focus();
  };
  if (qs) {
    $$('[data-qs-close]', qs).forEach((b) => b.addEventListener('click', closeQS));
    $('[data-qs-add]', qs).addEventListener('click', () => { addToCart(qsPick); closeQS(true); openCart(); });
    qs.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') return closeQS();
      if (e.key !== 'Tab') return;
      const f = $$('button, summary, a[href]', qs).filter((x) => x.offsetParent);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    });
  }
  $$('[data-quick]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    const d = JSON.parse(b.dataset.quick);
    if (d.v.length > 1 && qs) return openQS(d, b);
    addToCart(d.v[0][0]);
    b.classList.add('is-added');
    setTimeout(() => b.classList.remove('is-added'), 1400);
    openCart();
  }));
  // product page: the size-guide link under Short/Long opens the guide
  $$('[data-open-guide]').forEach((a) => a.addEventListener('click', (e) => {
    const d = $('#size-guide'); if (!d) return;
    e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }));
  renderCart();
  if (SHOP) syncCart();

  /* ---------- product page ---------- */
  const form = $('[data-pdp-form]');
  if (form) {
    let qty = 1;
    const out = $('[data-qty]', form);
    const priceEl = $('[data-pdp-price] .price');
    const barPrice = $('[data-bar-price]');
    const current = () => form.querySelector('[name=variant]:checked') || form.querySelector('[name=variant]');
    const option = () => form.querySelector('[name=combo]:checked')?.value || '';
    const ptsEl = $('[data-pts]');
    const update = () => { const p = current().dataset.price; priceEl && !priceEl.querySelector('s') && (priceEl.textContent = inr(p)); if (barPrice) barPrice.textContent = inr(p * qty); if (ptsEl) ptsEl.textContent = pts(p * qty);
      // theme: keep Shopify's hidden variant id current, for apps that read the product form
      const idIn = form.querySelector('[name=id]'); const sid = SHOP && SHOP.variant[current().value + (option() ? '|' + option() : '')]; if (idIn && sid) idIn.value = sid; };
    $$('[name=combo]', form).forEach((r) => r.addEventListener('change', update));
    $$('[name=variant]', form).forEach((r) => r.addEventListener('change', update));
    $('[data-inc]', form).addEventListener('click', () => { qty = Math.min(20, qty + 1); out.textContent = qty; update(); });
    $('[data-dec]', form).addEventListener('click', () => { qty = Math.max(1, qty - 1); out.textContent = qty; update(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(current().value, qty, option()); openCart(); });
    $('[data-buy-now]').addEventListener('click', () => { const p = addToCart(current().value, qty, option()); if (SHOP) p.then(() => { location.href = '/checkout'; }); else openCart(); });
    $('[data-bar-add]')?.addEventListener('click', () => { addToCart(current().value, qty, option()); openCart(); });
    // sold out on Shopify: the bar's Notify me opens Essential's back-in-stock pop-up (the theme has no #notify form)
    document.addEventListener('click', (e) => { if (!e.target.closest('a[href="#notify"]') || $('#notify')) return; const b = $('[class*=essential-preorder-back-in-stock]'); if (b) { e.preventDefault(); b.click(); } }, true);
    const bar = $('[data-buy-bar]');
    // the bar shows only once the page's own Add to cart has scrolled above the screen; checked on every scroll, so jumps
    // (restored scroll, End/Home keys, anchors) can never leave it in the wrong state (responsive sweep, 2026-10-09)
    const acts = $('[data-pdp-actions]');
    if (bar && acts) {
      let q = 0;
      const sync = () => { q = 0; bar.hidden = acts.getBoundingClientRect().bottom > 0; };
      const ask = () => { if (!q) q = requestAnimationFrame(sync); };
      addEventListener('scroll', ask, { passive: true }); addEventListener('resize', ask); addEventListener('pageshow', sync); sync();
    }
    // complete the set: this product + its partner in the same print; the price shown is what the cart will charge
    const set = $('[data-set]');
    if (set) {
      const d = JSON.parse(set.dataset.set);
      const pick = () => d.v[+(set.querySelector('[name=set-size]:checked')?.value || 0)];
      const sync = () => {
        const was = +current().dataset.price + pick()[1];
        $('[data-set-total]', set).textContent = inr(was - Math.round((was * d.pct) / 100));
        $('[data-set-was]', set).textContent = inr(was);
      };
      $$('[name=variant]', form).forEach((r) => r.addEventListener('change', sync));
      $$('[name=set-size]', set).forEach((r) => r.addEventListener('change', sync));
      sync();
      $('[data-set-add]', set).addEventListener('click', () => { addToCart(current().value, 1, option()); addToCart(pick()[0], 1); openCart(); });
      // the two photos slide together once, as the pair comes into view
      if (!reduced) {
        const [a, b] = $$('.set-img', set);
        G.from(a, { x: -18, rotation: -4, duration: 0.7, scrollTrigger: { trigger: set, start: 'top 85%', once: true } });
        G.from(b, { x: 18, rotation: 4, duration: 0.7, scrollTrigger: { trigger: set, start: 'top 85%', once: true } });
        G.from($('.set-plus', set), { scale: 0.4, rotation: -90, opacity: 0, duration: 0.5, delay: 0.25, scrollTrigger: { trigger: set, start: 'top 85%', once: true } });
      }
    }
    // print swatches: hovering one previews its print name
    const swName = $('.sw-name');
    if (swName) {
      const own = swName.textContent;
      $$('.sw').forEach((s) => {
        const name = s.dataset.print[0].toUpperCase() + s.dataset.print.slice(1);
        s.addEventListener('pointerenter', () => { swName.textContent = name; });
        s.addEventListener('pointerleave', () => { swName.textContent = own; });
      });
    }
  }

  /* ---------- search: a sheet from the top, live results from the 13 products and 4 collections ---------- */
  const srch = $('[data-search]');
  if (srch) {
    const input = $('[data-search-input]', srch), list = $('[data-search-list]', srch), empty = $('[data-search-empty]', srch), ph = $('[data-search-ph]', srch);
    const IDX = window.TW_SEARCH || { prods: [], cats: [] };
    const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>';
    const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const norm = (t) => t.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    const mark = (name, toks) => {
      let out = esc(name);
      toks.forEach((t) => { if (t.length > 1) out = out.replace(new RegExp(`(${t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig'), '<mark>$1</mark>'); });
      return out;
    };
    const row = (r, toks) => `<li><a class="srch-row" href="${r.u}" data-print="${r.pr}"><img src="${r.i}" alt="" width="52" height="64" loading="lazy"><span><span class="srch-name">${mark(r.n, toks)}</span><span class="srch-meta">${[r.k, r.so || r.pz].filter(Boolean).join(' · ')}</span></span>${ARROW}</a></li>`;
    const group = (t) => `<li class="srch-group" aria-hidden="true">${t}</li>`;
    let active = -1, opener = null, phTimer = 0;
    const rows = () => $$('.srch-row', list);
    const setActive = (k) => {
      const r = rows(); if (!r.length) return;
      active = (k + r.length) % r.length;
      r.forEach((x, i) => x.classList.toggle('is-active', i === active));
      r[active].scrollIntoView({ block: 'nearest' });
    };
    const run = () => {
      const raw = input.value.trim(), q = norm(raw), toks = q ? q.split(' ') : [];
      ph.hidden = !!input.value;
      $$('.srch-chip', srch).forEach((c) => c.setAttribute('aria-pressed', String(norm(c.dataset.q) === q)));
      if (!toks.length) {
        list.innerHTML = group($('.desk-nav a[href="/collections/all"]')?.textContent || 'SHOP') + IDX.cats.map((r) => row(r, [])).join('') + IDX.prods.filter((r) => !r.so).map((r) => row(r, [])).join('');
        empty.hidden = true; active = -1; return;
      }
      const hit = (r) => toks.every((t) => norm(r.t).includes(t));
      const score = (r) => { const n = norm(r.n); return n.startsWith(q) ? 0 : n.includes(q) ? 1 : 2; };
      const res = [...IDX.cats.filter(hit), ...IDX.prods.filter(hit)].sort((a, b) => score(a) - score(b));
      list.innerHTML = res.map((r) => row(r, toks)).join('');
      empty.hidden = res.length > 0;
      empty.textContent = `No matches for “${raw}”`;
      active = res.length ? -1 : -1;
    };
    // the empty field suggests what to type, a word at a time (static with reduced motion)
    const WORDS = ['Paradise', 'hair wrap', 'Blush', 'value packs', 'Maze', 'towels', 'Scripted', 'Techno'];
    let w = 0;
    const showWord = () => {
      ph.innerHTML = `Search <b>${WORDS[w % WORDS.length]}</b>`;
      if (!reduced) $('b', ph).classList.add('is-in');
      w++;
    };
    const open = () => {
      if (!srch.hidden) return;
      opener = document.activeElement;
      srch.hidden = false; lenis?.stop();
      run(); showWord();
      if (!reduced) {
        phTimer = setInterval(() => { if (!input.value) showWord(); }, 2200);
        G.fromTo('.srch-panel', { yPercent: -4, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.35, overwrite: true });
        G.fromTo('.srch-scrim', { opacity: 0 }, { opacity: 1, duration: 0.3, overwrite: true });
      }
      input.focus({ preventScroll: true });
    };
    const close = () => {
      if (srch.hidden) return;
      clearInterval(phTimer);
      const done = () => { srch.hidden = true; lenis?.start(); opener?.focus?.({ preventScroll: true }); };
      if (reduced || document.hidden) return done();
      G.to('.srch-panel', { yPercent: -4, opacity: 0, duration: 0.2, overwrite: true, onComplete: done });
      G.to('.srch-scrim', { opacity: 0, duration: 0.2, overwrite: true });
    };
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-search-close]', srch).forEach((b) => b.addEventListener('click', close));
    input.addEventListener('input', run);
    $$('.srch-chip', srch).forEach((c) => c.addEventListener('click', () => {
      input.value = c.getAttribute('aria-pressed') === 'true' ? '' : c.dataset.q;
      run(); input.focus({ preventScroll: true });
    }));
    srch.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { e.preventDefault(); return close(); }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); return setActive(active + (e.key === 'ArrowDown' ? 1 : -1)); }
      if (e.key === 'Enter' && e.target === input) { const r = rows()[Math.max(0, active)]; if (r) { e.preventDefault(); r.click(); } return; }
      if (e.key !== 'Tab') return; // keep focus inside the sheet
      const f = $$('input, button, a[href]', srch).filter((x) => x.offsetParent);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f.at(-1).focus(); }
      else if (!e.shiftKey && document.activeElement === f.at(-1)) { e.preventDefault(); f[0].focus(); }
    });
    // "/" or Ctrl/Cmd+K opens search from anywhere (not while typing in a field)
    addEventListener('keydown', (e) => {
      const typing = e.target.closest?.('input, textarea, select, [contenteditable]');
      if ((e.key === '/' && !typing) || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k')) { e.preventDefault(); open(); }
    });
  }

  /* ---------- towel curtain: page changes hang a towel in the next page's print on the rope ---------- */
  const curtainEl = $('[data-curtain]');
  if (curtainEl) {
    const PAGES = window.TW_PAGES || {};
    const nameEl = $('[data-curtain-name]', curtainEl);
    const fit = () => nameEl.classList.toggle('is-long', nameEl.textContent.length > 20);
    fit();
    addEventListener('pageshow', (e) => { if (e.persisted) { curtainEl.classList.remove('is-drop'); root.classList.remove('curtain-in'); } });
    // warm the next page while the pointer is on its link, so the towel lifts as soon as it lands
    const warm = new Set();
    const pageOf = (a) => {
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return null;
      const u = new URL(a.href, location.href);
      if (u.origin !== location.origin) return null;
      const file = u.pathname.split('/').pop() || 'index.html';
      if (!PAGES[file]) return null;
      if (u.pathname === location.pathname && u.hash) return null; // same-page anchors scroll instead
      return { u, file };
    };
    addEventListener('pointerover', (e) => {
      const t = pageOf(e.target.closest?.('a[href]'));
      if (!t || warm.has(t.file)) return;
      warm.add(t.file);
      const l = document.createElement('link'); l.rel = 'prefetch'; l.href = t.u.href; document.head.appendChild(l);
    }, { passive: true });
    if (!reduced) document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest('a[href]'), t = pageOf(a);
      if (!t) return;
      e.preventDefault();
      const [label, print] = PAGES[t.file];
      curtainEl.dataset.print = print; nameEl.textContent = label; fit();
      curtainEl.classList.remove('is-drop'); void curtainEl.offsetWidth; curtainEl.classList.add('is-drop');
      try { sessionStorage.setItem('tw-curtain', '1'); } catch (err) {}
      setTimeout(() => { location.href = t.u.href; }, document.hidden ? 0 : 450);
    });
  }

  /* ---------- peg cursor: a clothes peg follows the mouse; it opens over products and takes a bit of their print ---------- */
  const peg = $('[data-peg]');
  if (peg && !reduced && matchMedia('(any-hover: hover) and (any-pointer: fine)').matches) { // any mouse or trackpad, also on touchscreen laptops
    root.classList.add('has-peg');
    let x = -100, y = -100, px = -100, vx = 0, frame = 0;
    const tick = () => {
      frame = 0;
      vx += (x - px - vx) * 0.25; px = x;
      const swing = Math.max(-16, Math.min(16, vx * 0.7)); // the peg swings with the hand, then settles
      peg.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${-28 + swing}deg)`;
      if (Math.abs(vx) > 0.05) frame = requestAnimationFrame(tick);
    };
    addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      peg.classList.add('is-on');
      if (!frame) frame = requestAnimationFrame(() => { tick(); root.classList.add('peg-live'); });
    }, { passive: true });
    document.documentElement.addEventListener('pointerleave', () => peg.classList.remove('is-on'));
    addEventListener('blur', () => peg.classList.remove('is-on'));
    document.addEventListener('pointerover', (e) => {
      const t = e.target;
      peg.classList.toggle('is-text', !!t.closest('input:not([type=radio]):not([type=checkbox]), textarea, select, [contenteditable]'));
      const prod = t.closest('[data-card], .towel, .sw, .srch-row, .set-img, .srch-chip');
      peg.classList.toggle('is-grab', !!prod);
      peg.classList.toggle('is-act', !prod && !!t.closest('a, button, label, summary, [role=button]'));
      if (prod) peg.style.setProperty('--swatch', getComputedStyle(prod.closest('[data-print]') || prod).getPropertyValue('--p'));
    });
    addEventListener('pointerdown', () => peg.classList.add('is-press'));
    addEventListener('pointerup', () => peg.classList.remove('is-press'));

  }


  /* ---------- Shop page video: plays only when motion is welcome and the data is not limited ---------- */
  const catVideo = $('[data-cat-video]');
  if (catVideo && !reduced && !navigator.connection?.saveData) { catVideo.play?.().catch(() => {}); }
})();
